import { defineComponent as m, computed as l, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as h } from "vue";
const p = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "dc95b229-f0ee-42d3-b07a-ac20583452f3" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), z = { mask: "url(#dc95b229-f0ee-42d3-b07a-ac20583452f3)" }, k = { key: 0 }, u = /* @__PURE__ */ h('<path fill="#eee" d="M0 0h512v512H0Z"></path><path fill="#333" d="m350 335 24-24 16 16-24 23zm-39 39 24-24 15 16-23 24zm87 8 23-24 16 16-24 24zm-40 39 24-23 16 15-24 24Zm16-63 24-23 15 15-23 24zm-39 40 23-24 16 16-24 23zm63-221-63-63 15-15 64 63zm-63-15-24-24 16-16 23 24zm39 39-24-24 16-15 24 23zm8-87-24-23 16-16 24 24Zm39 40-23-24 15-16 24 24ZM91 358l63 63-16 16-63-63zm63 16 23 24-15 15-24-23zm-40-39 24 23-16 16-23-24zm24-24 63 63-16 16-63-63zm16-220-63 63-16-16 63-63zm23 23-63 63-15-16 63-63zm24 24-63 63-16-16 63-63z"></path><path fill="#d80027" d="M319 319 193 193a89 89 0 1 1 126 126z"></path><path fill="#0052b4" d="M319 319a89 89 0 1 1-126-126z"></path><circle cx="224.5" cy="224.5" r="44.5" fill="#d80027"></circle><circle cx="287.5" cy="287.5" r="44.5" fill="#0052b4"></circle>', 6), g = { fill: "none" }, v = ["r"], b = /* @__PURE__ */ m({
  __name: "kr",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(a) {
    const e = a, o = l(() => 512 + 2 * e.strokeWidth), c = l(() => -e.strokeWidth), s = l(() => 256 + e.strokeWidth / 2);
    return (x, y) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", z, [
        e.flagName ? (i(), r("title", k, d(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: s.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, v)
      ])
    ], 8, p));
  }
});
export {
  b as default
};
//# sourceMappingURL=kr-d7f978a0.js.map
